// Pathify
import { make } from "vuex-pathify";

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  items: [
    {
      title: "Dashboard",
      icon: "mdi-view-dashboard",
      to: "/"
    },
    {
      title: "Users",
      icon: "mdi-account",
      to: "/users"
    },
    {
      title: "Folders",
      icon: "mdi-clipboard-outline",
      to: "/folders"
    },
    {
      title: "Recieved",
      icon: "mdi-file-replace",
      to: "/recieved"
    }
    // {
    //   title: "Notifications",
    //   icon: "mdi-bell",
    //   to: "/components/notifications/"
    // }
  ]
};

const mutations = make.mutations(state);

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    //
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
